var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 16,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 16,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 6,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 18,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 4,
    y2: 14,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 8,
    y2: 14,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 14,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 16,
    y2: 14,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 20,
    y2: 14,
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.23425aa3ae244970ced9802de4b8f2a7.svg";
export { ForwardRef as ReactComponent };